export async function getAllDeptos() {
  try {
    const url = 'http://54.232.174.205:3001/categories'; // define a url
    const request = await fetch(url); // faz a request
    const response = await request.json();
    return response;
  } catch (error) {
    return (error);
  }
}

export async function getSubMenusFromDepartment(id) {
  try {
    const url = `http://54.232.174.205:3001/categories/${id}`;
    const request = await fetch(url);
    const response = await request.json();
    return response;
  } catch (error) {
    return (error);
  }
}
